import React from 'react';

import {
    Button,
    Flex,
    Grid,
    Input,
    Loader,
    MultiSelect,
    Space,
    Stack,
    Text, Textarea,
} from '@mantine/core';
import { Link } from 'react-router-dom';

import useGamesData from './hooks/useGamesData';
import useVideoData from './hooks/useVideoData';
import FastImageLoad from '../../blocks/fast_image_load';
import VideoFrame from '../../components/VideoFrame';
import { PROJECT_PREFIX } from '../../const';
import PageFrame from '../../layouts/PageFrame';

function Video({ match }) {
    const { params: { id } } = match;

    const {
        data,
        embedData,
        handleChange,
        handleSubmit,
        handleSubmitAndLeave,
    } = useVideoData({ id });

    const {
        data: gamesData,
        selected,
        loading,
        query,
        handleChangeQuery,
        handleGamesSelect,
    } = useGamesData({
        selected: data.games,
        onGameSelect: (games) => handleChange('games')(games),
    });

    return (
        <PageFrame type="videos">
            <Grid columns={4} gap="md">
                <Grid.Col span={2}>
                    <Stack>
                        <Input.Wrapper label="Ссылка на YouTube или ВК Видео" withAsterisk>
                            <Input
                                value={data.url}
                                onChange={handleChange('url')}
                                placeholder="Укажите ссылку на YouTube или ВК Видео"
                            />
                        </Input.Wrapper>
                        <Input.Wrapper label="Заголовок" withAsterisk>
                            <Input
                                value={data.title}
                                onChange={handleChange('title')}
                                placeholder="Укажите заголовок"
                            />
                        </Input.Wrapper>
                        <Textarea
                            label="Описание"
                            value={data.description}
                            onChange={handleChange('description')}
                            placeholder="Укажите описание"
                            withAsterisk
                        />
                        <MultiSelect
                            label="Укажите игры"
                            value={selected}
                            onChange={handleGamesSelect}
                            data={gamesData}
                            searchValue={query}
                            onSearchChange={handleChangeQuery}
                            searchable
                            rightSection={loading && <Loader size="xs" />}
                            required
                        />
                        <Space h="xl" />
                        <Flex gap="md">
                            <Button variant="outline">
                                <Link to={`${PROJECT_PREFIX}/video/`}>Назад</Link>
                            </Button>
                            <Button variant="outline" onClick={handleSubmit}>
                                Применить
                            </Button>
                            <Button onClick={handleSubmitAndLeave}>
                                Сохранить
                            </Button>
                        </Flex>
                    </Stack>
                </Grid.Col>
                <Grid.Col span={2}>
                    <FastImageLoad
                        label="Обложка"
                        image={data.preview}
                        restrictions="Разрешение не менее 1280x720. Формат: jpeg, png, webp."
                        minSize="1280x720"
                        onChange={handleChange('preview')}
                        required
                    />
                    <Space h="xl" />
                    {embedData?.src && (
                        <Stack>
                            <Text fs="italic">
                                Обнаруженное видео:
                                {' '}
                                {embedData.src}
                            </Text>
                            <VideoFrame url={embedData?.src} title={data.title} />
                        </Stack>
                    )}
                </Grid.Col>
            </Grid>
        </PageFrame>
    );
}

export default Video;
